<ng-container *ngIf="isMerchantGU else otherPayMethods">
  <h1 class="pl-align">{{ 'title-pay-agency-bam' | translation | async }}</h1>
  <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
  <div class="methodForm">
    <div *ngIf="isBamPaymethod">
      <p innerHTML="{{ 'cash-ByCovenant-new' | translation | async }}"></p>
    </div>
    <div *ngIf="isBiPaymethod">
      <p innerHTML="{{ 'cash-ByCovenant' | translation | async }}"></p>
    </div>
    <app-copy-to-clipboard [value]="ref_bam"></app-copy-to-clipboard>
    <div *ngIf="isBamPaymethod"> {{ 'reference-number' | translation | async }} </div>
    <div *ngIf="isBiPaymethod"> {{ 'reference-new' | translation | async }} </div>
    <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
    <div *ngIf="isBamPaymethod"> {{ 'reduction-quote-type' | translation | async }} </div>
  </div>
</ng-container>

<ng-template #otherPayMethods>
  <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
  <div class="methodForm">
    <app-counter-item #counterItems [number]="1">
      <div *ngIf="isMerchantCR; else elseBlockOne">
        <p id="steps-description" innerHTML="{{ 'cash-ByCovenant-new' | translation | async }}"></p>
      </div>
      <ng-template #elseBlockOne>
        <div *ngIf="isHeyPayMethod && ptosHeyPdfDownloadFF else otherCommercialNetworks">
          <p>
            <span innerHTML="{{ 'cash-ptos-hey-info-1' | translation | async }}"></span>
            <a class="pdf-link" target="_blank" rel="noopener noreferrer" [href]="ptosHeyPdf">{{ 'cash-ptos-hey-info-2' | translation | async }}</a>
            <span innerHTML="{{ 'cash-ptos-hey-info-3' | translation | async }}"></span>
          </p>
        </div>
        <ng-template #otherCommercialNetworks>
          <p id="steps-description" innerHTML="{{ 'cash-ByCovenant' | translation | async }}"></p>
        </ng-template>
      </ng-template>
      <div *ngIf="isMerchantCR; else elseBlockTwo">
        <div class="subtitle">{{ 'agreement-new' | translation | async }}</div>
      </div>
      <ng-template #elseBlockTwo>
        <div class="subtitle">{{ 'agreement' | translation | async }}</div>
      </ng-template>
      <app-copy-to-clipboard [value]="currentConcept.number"></app-copy-to-clipboard>
      <div *ngIf="isMerchantCR; else elseBlockThree">
        <div class="subtitle">{{ 'reference-new' | translation | async }}</div>
      </div>
      <ng-template #elseBlockThree>
        <div class="subtitle">{{ 'reference' | translation | async }}</div>
      </ng-template>
      <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
    </app-counter-item>
    <app-counter-item #counterItems [number]="2">
      <p id="steps-description" innerHTML="{{ 'cash-InstructRef' | translation | async }}"></p>
    </app-counter-item>
    <div *ngIf="isMerchantCR" class="subtitle center">{{ 'automatic-approval' | translation | async }}
    </div>
    <ng-container *ngIf="downloadInstructionButtonFF">
      <app-download-cash-instructions-button [networkName]="this.info.name"
        [agreementNetworkCode]="this.info?.concept[0]?.number"
        [referenceCode]="transaction.ORDER_REFERENCE"></app-download-cash-instructions-button>
    </ng-container>
  </div>
</ng-template>
